<template>
        <GroupList />
</template>

<script>
import GroupList from './group_list.vue'

export default {
    data() {
        return {
        }
    },
    components : {
        GroupList
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            this.$store.commit('setBreadCrumbs',[{text: 'Groups', href: '/groups'}])//#
        }
    }
}
</script>

